/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/** Canonical analytics identifier for the Search input screen. */
export const SEARCH_SCREEN_ANALYTICS_ID: string = "search";

/** Canonical analytics screen label for the Search input screen. */
export const SEARCH_SCREEN_ANALYTICS_NAME: string = "Search";

/** Canonical analytics identifier for the Search Results screen. */
export const SEARCH_RESULTS_ANALYTICS_ID: string = "search_results";

/** Canonical analytics screen label for the Search Results screen. */
export const SEARCH_RESULTS_ANALYTICS_NAME: string = "SearchResults";

/** Minimum query length before a PCD search request is triggered (PRD §2.6.2.1-2). */
export const SEARCH_MIN_QUERY_LENGTH: number = 3;

/** Maximum query length accepted by the search input (PRD §2.2.5). */
export const SEARCH_MAX_QUERY_LENGTH: number = 100;

/** Debounce interval applied between a keystroke and the PCD API call (PRD §2.6.2.5). */
export const SEARCH_DEBOUNCE_MS: number = 300;

/** Client-side abort threshold for a single smart-search request (PRD §3.3.2/§3.4.4). */
export const SEARCH_API_TIMEOUT_MS: number = 3000;

/** Delay before the single automatic retry of a failed search request (PRD §3.3.3). */
export const SEARCH_RETRY_DELAY_MS: number = 500;

/** Maximum number of Recently Searched terms retained, FIFO (PRD §2.4.3-4). */
export const SEARCH_MAX_RECENT_SEARCHES: number = 6;

/**
 * Distance (in carousel rows) from the last loaded rail at which the next
 * page of result carousels is prefetched via the server pageCursor. Mirrors
 * the homescreen CAROUSEL_RAIL_PREFETCH_THRESHOLD.
 */
export const SEARCH_CAROUSEL_PREFETCH_THRESHOLD: number = 2;
